/** Get List All Kids Music  */
export const FETCH_ALL_KIDS_MUSIC = "FETCH_ALL_KIDS_MUSIC";
export const FETCH_ALL_KIDS_MUSIC_SUCCESS = "FETCH_ALL_KIDS_MUSIC_SUCCESS";
export const FETCH_ALL_KIDS_MUSIC_ERROR = "FETCH_ALL_KIDS_MUSIC_ERROR";

/** Get List All Topics  */
export const FETCH_ALL_TOPICS = "FETCH_ALL_TOPICS";
export const FETCH_ALL_TOPICS_SUCCESS = "FETCH_ALL_TOPICS_SUCCESS";
export const FETCH_ALL_TOPICS_ERROR = "FETCH_ALL_TOPICS_ERROR";
